import { render, staticRenderFns } from "./add-risk-attendance.view.vue?vue&type=template&id=578f29b5&scoped=true&"
import script from "./add-risk-attendance.view.vue?vue&type=script&lang=ts&"
export * from "./add-risk-attendance.view.vue?vue&type=script&lang=ts&"
import style0 from "./add-risk-attendance.view.vue?vue&type=style&index=0&id=578f29b5&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578f29b5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
